import { DatasetMetadata, DatasetType, OnlineStorage } from "@tblabs/storage";
import { RefString, Line, Snack } from "@tblabs/truffle";
import { Bold } from "../Components/Bold";
import { JsonEditor } from "../Components/JsonEditor";
import { Panel } from "../Components/Panel";
import { PrimaryButton } from "../Components/PrimaryButton";
import { Page } from "./Page";


export class DataseMetadataEditPage extends Page
{
    private metadata!: DatasetMetadata;
    private itemAsString = new RefString();
    private snack?: Snack;

    constructor(private _storage: OnlineStorage, private datasetName: string)
    {
        super(`${datasetName} metadata edit`);

        this.Content(async (body) =>
        {
            try
            {
                this.metadata = await this._storage.GetDatasetMetadata(this.datasetName);
            }
            catch (ex)
            {
                this.metadata = {
                    Type: "Object|Text|Picture|File",
                    CreatedBy: _storage.User?.Id || "Anonymous",
                    CreatedAt: new Date(),
                };

                this.ShowSnack("Metadata not found", "Set proper type and save");
            }

            this.itemAsString.value = JSON.stringify(this.metadata, null, 2);

            body.Append(
                new Panel([new Bold(this.datasetName), " dataset metadata edit"], [
                    new Line(),
                    new PrimaryButton("Save").OnClick(async () => await this.SaveMetadata()),
                ]),
                new Panel("Content to edit", [
                    new JsonEditor(this.itemAsString),
                ])
            );
        });
    }

    private async SaveMetadata(): Promise<void>
    {
        try
        {
            const metadata = JSON.parse(this.itemAsString.value);
            if (![DatasetType.Object, DatasetType.Text, DatasetType.Picture, DatasetType.File].includes(metadata.Type as DatasetType))
            {
                throw new Error(`Dataset type "${metadata.Type}" is not valid. Should be one of: ${[DatasetType.Object, DatasetType.Text, DatasetType.Picture, DatasetType.File].join(", ")}`);
            }

            await this._storage.UpdateDatasetMetadata(this.datasetName, metadata);
            this.ShowSnack("Metadata saved");
            window.location.hash = `admin/dataset/${this.datasetName}/view`;
        }
        catch (ex: any)
        {
            this.ShowSnack("Saving metadata problem", ex.message);
        }
    }

    private ShowSnack(title: string, message: string = ""): void
    {
        this.snack?.Hide();

        this.snack = new Snack(title, message, { autoCloseTimeout: 0, clickAnywhereToClose: true });
    }

    protected async OnRemove()
    {
        setTimeout(() =>
        {
            this.snack?.Hide();
        }, 1500);
    }
}
